var SCM = SCM || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

(function (ail, $) {
    var retrieveAiLayAbstract = function (articleId) {
        var selector = '.js-ai-generated-abstract';
        var parentSelector = '.js-ai-generated-response-wrap';

        SCM.Ajax.get('/Ai/ArticleAiLayAbstractAjax', { articleId: articleId })
            .expectJson()
            .then(function (data) {
                $(selector).html(data);
                $(parentSelector).show();
            })
            .catch(function (err) {
                console.log(err);
                $(selector).html('Please try again later.');
                $(parentSelector).show();
            });
    };

    ail.init = function () {
        $('.js-open-ailayabstract').one('click', function () {
            var articleId = $('.js-ai-layabstract-wrap').data('articleid');
            retrieveAiLayAbstract(articleId);
        });

        $('.js-open-ailayabstract').on('click', function () {
            $('.js-ai-generated-response-wrap').toggle();
        });
    };
})(SCM.SharedWidgets.ArticleAiLayAbstract = SCM.SharedWidgets.ArticleAiLayAbstract || {}, jQuery);
